import React from 'react';
import { Trophy, X, Minus, Clock, Coins } from 'lucide-react';
import { useGameHistory } from '../../hooks/useGameHistory';
import { formatDistanceToNow } from '../../utils/date';
import { truncateAddress } from '../../utils/format';

export function LiveGameHistory() {
  const { history, loading, error } = useGameHistory();

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-500" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-400 text-center py-8">
        {error}
      </div>
    );
  }

  const getResultIcon = (result: string) => {
    switch (result) {
      case 'win':
        return <Trophy className="w-4 h-4 text-green-400" />;
      case 'lose':
        return <X className="w-4 h-4 text-red-400" />;
      default:
        return <Minus className="w-4 h-4 text-blue-400" />;
    }
  };

  return (
    <div className="bg-gray-900 rounded-xl p-6">
      <h2 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
        <Coins className="w-6 h-6 text-yellow-400" />
        Live Betting History
      </h2>

      <div className="space-y-4">
        {history.slice(0, 10).map((game) => (
          <div
            key={game.id}
            className="bg-gray-800 p-4 rounded-lg grid grid-cols-6 gap-4 items-center"
          >
            <div className="text-white font-serif">{game.username}</div>
            <div className="text-gray-400 font-mono text-sm">
              {truncateAddress(game.walletAddress)}
            </div>
            <div className="text-cyan-400">{game.gameType}</div>
            <div className="flex items-center gap-2">
              {getResultIcon(game.result)}
              <span className={`
                ${game.result === 'win' ? 'text-green-400' : 
                  game.result === 'lose' ? 'text-red-400' : 
                  'text-blue-400'}
              `}>
                {game.result.toUpperCase()}
              </span>
            </div>
            <div className="text-yellow-400 font-mono">
              {game.betAmount.toLocaleString()} coins
            </div>
            <div className="text-gray-400 text-sm flex items-center gap-1">
              <Clock className="w-4 h-4" />
              {formatDistanceToNow(new Date(game.timestamp))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}